import React, { useEffect, useState, useContext } from "react";
import * as Helpers from '../helpers.mjs';
import AddToBasket from './AddToBasket.js';
import OrderTrackIcons from './OrderTrackIcons.js';
import OfferLink from './OfferLink.js';
import { useElasticData, useExtraData } from "./DataContext.js";

const BookPackControls = () => {
    let { elasticData, product } = useElasticData();
    let { extraData, isGuestUser, isSchoolsUser, isForSchoolBasket } = useExtraData();

    if (!extraData) {
        return null;
    }

    const pds = elasticData;
    const productEan13 = pds.id;
    const [productPrice, setProductPrice] = useState(0);
    const hasMaxPrice = (pds.max_price != null && pds.max_price != pds.min_price);
    const [productRrp, setProductRrp] = useState(0);
    const stepValueInit = pds.increment ?? 10;
    let stepValue = stepValueInit;
    let productDiscount = pds.discount;
    // const hasNoPrimaryCandidates = (!pds.primary_candidates || pds.primary_candidates?.length == 0);

    // const range = pds.max_price - pds.min_price;
    // const steps = range/initStepValue;
    // const stepValue = range/Math.round(steps);

    // console.log("steps", steps);
    // console.log("initStepValue", initStepValue);
    // console.log("stepValue", stepValue);

    let orderedBefore = extraData.orderedBefore;
    let isForSchoolBasketRes = isForSchoolBasket();
    let isSchoolUserRes = Helpers.isSchoolUser();
    let isInternalUserRes = Helpers.isInternal();

    var offerLink = null;
    if (isSchoolUserRes || isForSchoolBasketRes) {
        if (extraData.offerPage != null) {
            offerLink = <OfferLink link={"/" + extraData.offerPage} heading="Special offer" name={extraData.offerGroupName} ofId={extraData.offerGroupId} />
        } else if (extraData.offerMinQuantity > 1) {
            offerLink = <OfferLink link={null} heading="Class set offer" name={`Order ${extraData.offerMinQuantity} or more copies of this title and get ${extraData.offerDiscount}% off the RRP`} ofId={extraData.offerGroupId} />
        } else if (extraData.offerGroupName) {
            offerLink = <OfferLink link={null} heading="Special offer" name={extraData.offerGroupName} ofId={extraData.offerGroupId} />
        }
    }

    function updateBookPackDetails(price, discount) {
        setProductPrice(price);
        let bookPackRrpCalculation = (price / (1 - discount));
        setProductRrp(bookPackRrpCalculation);
        // if (hasNoPrimaryCandidates && hasMaxPrice && extraData) {
        //     const averageBookPrice = Number(pds.min_price / extraData.approxBooks);
        //     const newApproxBooksCount = Number(price / averageBookPrice);
        //     $('p.needMore.approxBooks').find('span').html(`This pack contains approximately ${newApproxBooksCount} books.`);
        // }
    }

    useEffect(() => {
        updateBookPackDetails(pds.min_price, productDiscount);
    }, [productEan13]);

    return (
        <div className="deliveryInfo">
            {/* {hasMaxPrice && <div className="bookPackValueSlideContainer">
                <p>Select the amount you wish to spend</p>
                <input type="range" onChange={e => {
                    let max = Number(e.target.max); 
                    let min = Number(e.target.min);
                    let rv = max - min
                    let d = max - (rv % stepValue);
                    let v = Number(e.target.value);
                    updateBookPackDetails(e.target.value, productDiscount);
                    if (v >= d) {
                        let steps = rv/stepValueInit;
                        stepValue = rv/Math.round(steps);
                    } else {
                        stepValue = stepValueInit;
                    }
                    e.target.step = stepValue;
                }} min={pds.min_price} max={pds.max_price} step={stepValue} value={productPrice} id="bookPackValueRange" />
                <p className="sliderNumbers">
                    <span class="min">{Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(pds.min_price)}</span>
                    <span class="max">{Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(pds.max_price)}</span>
                </p>
            </div>} */}

            <h3 className="bookPrice">{Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(productPrice)}</h3>
            <div className="pricingBreakdown">
                <p className="rrp">
                    <strong>RRP&nbsp;{Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(productRrp)}</strong>
                    {productDiscount > 0 && <span className="savingPercent">{Intl.NumberFormat("en-GB", { style: "percent", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(productDiscount)}</span>}
                </p>
            </div>

            {orderedBefore && <div className="pricingBreakdown">
                <a href={`/isbn?isbn=${pds.id}`} target="_blank"><i style={{ color: '#ff006d' }} className="fas fa-shopping-basket" title="This title has been ordered before, or is currently in another basket"></i></a>
            </div>}
            {!isGuestUser && isSchoolsUser && <div className="stockSection">Available</div>}
            <input className="bookPackQuantity productQty" type="hidden" value={1} />
            <AddToBasket product={product} hit={elasticData} isBookPack={true} />
            {offerLink !== null && <div className="offerDetails offerDetailsBookPage">
                {offerLink}
            </div>}
            <OrderTrackIcons />
        </div>
    );
}

export default BookPackControls;
